function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { tempo } from "../system";
function CheckIcon(props) {
    return /*#__PURE__*/ _jsx(tempo.svg, _object_spread_props(_object_spread({
        width: "1.2em",
        viewBox: "0 0 12 10",
        style: {
            fill: 'none',
            strokeWidth: 1,
            stroke: 'currentColor',
            strokeDasharray: 16
        }
    }, props), {
        children: /*#__PURE__*/ _jsx("polyline", {
            points: "1.5 6 4.5 9 10.5 1"
        })
    }));
}
function IndeterminateIcon(props) {
    return /*#__PURE__*/ _jsx(tempo.svg, _object_spread_props(_object_spread({
        width: "1.2em",
        viewBox: "0 0 24 24",
        style: {
            stroke: 'currentColor',
            strokeWidth: 4
        }
    }, props), {
        children: /*#__PURE__*/ _jsx("line", {
            x1: "21",
            x2: "3",
            y1: "12",
            y2: "12"
        })
    }));
}
export function CheckboxIcon(props) {
    const { isIndeterminate, isChecked } = props, rest = _object_without_properties(props, [
        "isIndeterminate",
        "isChecked"
    ]);
    const BaseIcon = isIndeterminate ? IndeterminateIcon : CheckIcon;
    return isChecked || isIndeterminate ? /*#__PURE__*/ _jsx(tempo.div, {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
        },
        children: /*#__PURE__*/ _jsx(BaseIcon, _object_spread({}, rest))
    }) : null;
}

//# sourceMappingURL=CheckboxIcon.js.map